/** Generate a prompt from a configuration */

import { deepMerge, logger } from '@tunasong/models'
import invariant from 'tiny-invariant'
import type { AIContext, AIContextSettings } from './schema/ai-schema.js'
import type { SupportedModel } from './schema/providers.js'
import { getProviderByModel } from './schema/providers.js'
import { aiSystemContextSettings } from './system-context-settings.js'

export const getPromptSpec = ({ context, userConfig }: { context: AIContext; userConfig?: AIContextSettings }) => {
  const globalConfig = aiSystemContextSettings.global
  const systemConfig = aiSystemContextSettings[context]

  invariant(systemConfig, `No system context settings found for context: ${context}`)

  // Merge the system settings with the user settings
  const config = deepMerge(globalConfig, systemConfig, userConfig)

  // If the merged model is no longer supported (e.g., removed from providers), fall back to the system default
  if (config.model && !getProviderByModel(config.model as SupportedModel)) {
    logger.warn(`Model "${config.model}" is no longer supported, falling back to system default`)
    config.model = systemConfig.model ?? globalConfig.model
  }

  // Check that we have a specified provider and model
  invariant(config.model, 'No model specified in context settings')

  return config
}
